export const CRHeaderElements = [
  {
    label: "Nombre",
    value: "nombre",
  },
  {
    label: "Apellido",
    value: "apellido",
  },
  {
    label: "DNI",
    value: "dni",
  },
  {
    label: "Mail",
    value: "mail",
  },
  {
    label: "Celular",
    value: "telefono",
  },
  {
    label: "Estado",
    value: "estado",
  },
];
